import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";


const SingleCommentInteraction = ({
    isOwnedPost,
    item,
    handleEdit,
    setPostList,
    setSinglePostListInfo,
    singlepostListinfo,
    updateCommentCount,
    postList,
    singlepostList,
    postId,
    singlepostCommentList,
    setSinglePostCommentList,
    allPostComments,
}) => {
    // console.log('singlepostList', singlepostList);
    const { t } = useTranslation();
    const sessionId = localStorage.getItem("sessionId");
    const dropdownRef = useRef(null);

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);

    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const language = localStorage.getItem("Lang");

    const [showDropdown, setShowDropdown] = useState(false);
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    // Delete Post start
    const [show, setShow] = useState(false);
    const handleDeleteClose = () => {
        setShow(false);
    };

    const deleteComment = async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            id: item.pstCmntId,
                  langKey: language === "en" ? "" : language,

        };
        const scrollY = window.scrollY;

        try {
            const res = await axios.post(`PostAction/DeleteComment`, responseData);

            if (res?.data) {
                const updatedComments =
                    postList?.postInfo?.postInfo?.comments?.filter(
                        (comment) => comment?.pstCmntId !== item.pstCmntId
                    ) || [];
                // const updatedPostInfo = {
                //   ...postList.postInfo.postInfo,
                //   comments: updatedComments,
                //   commentCount: (postList.postInfo.postInfo.commentCount || 1) - 1,
                // };
                // const updatedPostList = {
                //   ...postList,
                //   postInfo: {
                //     ...postList.postInfo,
                //     postInfo: updatedPostInfo,
                //   },
                // };
                // setPostList(updatedPostList);

                // setSinglePostCommentList(prevComments =>
                //     prevComments.filter(c => c.pstCmntId !== item.pstCmntId)
                // );
                // updateCommentCount((prevCount) => (prevCount || 1) - 1)
                // setPostList(prev => {
                //     if (!prev) return prev;
                //     return {
                //         ...prev,
                //         postInfo: {
                //             ...prev.postInfo,
                //             postInfo: {
                //                 ...prev.postInfo.postInfo,
                //                 commentCount: (prev.postInfo.postInfo.commentCount || 1) - 1
                //             }
                //         }
                //     };
                // });

                setSinglePostCommentList((prevComments) =>
                    prevComments.filter((c) => c.pstCmntId !== item.pstCmntId)
                );
                setSinglePostListInfo((prev) => ({
                    ...prev,
                    postInfo: {
                        ...prev.postInfo,
                        comments: prev.postInfo.comments.filter(
                            (c) => c.pstCmntId !== item.pstCmntId
                        ),
                        commentCount: Math.max((prev.postInfo.commentCount || 1) - 1, 0),
                    },
                }));
                // 2) NewsFeed (global posts array) update karo
                setPostList((prevPosts) =>
                    prevPosts.map((post) => {
                        if (post?.postInfo?.postId === postId) {
                            return {
                                ...post,
                                postInfo: {
                                    ...post.postInfo,
                                    comments: post.postInfo.comments.filter(
                                        (c) => c.pstCmntId !== item.pstCmntId
                                    ),
                                    commentCount: Math.max(
                                        (post.postInfo.commentCount || 1) - 1,
                                        0
                                    ),
                                },
                            };
                        }
                        return post;
                    })
                );

                updateCommentCount((prev) => Math.max((prev || 1) - 1, 0));
                updateCommentCount((prevCount) =>
                    Math.max((prevCount || 1) - 1, 0)
                );



                setShow(false);
                setToastMessage(res.data.message);
                setShowToast(true);
                requestAnimationFrame(() => {
                    window.scrollTo(0, scrollY);
                });
            } else {
                throw new Error("No response data from API");
            }
        } catch (e) {
            console.error("Error in deleteComment:", e);
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data?.message || "Comment not found");
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response?.data?.message || "Something went wrong");
                setShowErrorToast(true);
            }
        }
    };


    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(null);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // useEffect(() => {
    //     if (show) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [show]);
    return (
        <>
            {(item?.isOwned || isOwnedPost) && (
                <div
                    className={`postMenu pointer commentInteraction${showDropdown ? " is-open" : ""}`}
                    onClick={() => setShowDropdown(!showDropdown)}
                >
                    <MoreHorizSharpIcon className="material-symbols-sharp" />

                    {showDropdown && (
                        <Dropdown.Menu
                            show={showDropdown}
                            ref={dropdownRef}
                            className="InteractionModal wlj-company-action-menu"
                            onClick={(event) => event.stopPropagation()}
                        >
                            {(item?.isOwned || isOwnedPost) && (
                                <Dropdown.Item as="button" className="dropdownList">
                                    <div
                                        onClick={() => {
                                            setShow(!show);
                                            toggleDropdown();
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                                            <span className="dropdownTxt f-14 redText">{t("Drafts.Delete")}</span>
                                        </div>
                                        <p className="f-12 dropdownPara">
                                            {t("Drafts.Once Deleted it can't be recovered")}
                                        </p>
                                    </div>
                                </Dropdown.Item>
                            )}
                            {item?.isOwned && (
                                <Dropdown.Item as="button" className="dropdownList">
                                    <div
                                        onClick={() => {
                                            handleEdit();
                                            // setEditedComment(item.comment);
                                            // setpstCmntId(item.pstCmntId);
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <EditSharpIcon className="material-symbols-sharp me-2" />

                                            <span className="dropdownTxt f-14">{t("Drafts.Edit")}</span>
                                        </div>
                                        <p className="f-12 dropdownPara">{t("Drafts.Edit Comment")}</p>
                                    </div>
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    )}
                </div>
            )}



            {show && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd wlj-overlay-modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "flex" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6 className="wlj-modal-title--danger">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp" />
                  {t("User Profile.Are You Sure You want to Delete?")}
                </h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleDeleteClose();
                                    }}
                                />
                            </div>

                            <div className="text-center mt-2">
                                <button
                                    color=""
                                    className="closebtn"
                                    onClick={() => deleteComment()}
                                >
                                    {t("Drafts.Delete")}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                </Portal>
            )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default SingleCommentInteraction;
